import * as React from "react";
import {Alert, Spinner, Button, Accordion, Card, Modal, Form, Row, Col} from "react-bootstrap";
import withRequestState from "../../components/WithRequestState";
import {connect} from "react-redux";
import { RequestStateProps } from "../../interfaces/RequestState";
import { State } from "../../interfaces/State";
import { withRouter, RouteComponentProps} from "react-router-dom";
import {getContractors, createContractor} from "../../redux/contractors/actions";
import {GET_CONTRACTORS_REQUEST} from "../../redux/contractors/reducer";
import {Contractor} from "../../interfaces/Contractors";
import CreateContractor from "../../modals/createContractor";
import "./index.scss";


interface IState {
    createContractor: boolean;
}

interface IProps {
    getContractors: () => void;
    contractors: Contractor[];
    createContractor: (contractorName: string, contractorDescription: string, contractorFirstName: string, contractorLastName: string, contractorMobileNumber: string, contractorWorkPhone: string, contractorEmail: string) => void;
}

class Contactors extends React.Component<IProps & RequestStateProps & RouteComponentProps, IState> {

    constructor(props){
        super(props);
        this.state = {
            createContractor: false
        }
    }

    componentDidMount(){
        this.props.getContractors();
    }

    render(){
        return (
            <div id="contractor-page">
                <div className="top-banner p-4">
                    <h3>Contractors</h3>
                </div>
                <div className="p-4">  

                    <h4>Contractors list</h4>
                    <p>Bla bla bla</p>


                    <div className="mt-4">
                        {
                            this.props.isPending ? 
                            <Spinner animation="border" /> :
                                <div className="list">
                                    <Row className="list-header mt-3 p-3" noGutters>
                                        <Col md={1} xs={1}>#</Col>
                                        <Col>Contractor name</Col>
                                    </Row>
                                    <div>
                                    {
                                        this.props.contractors.map((user, index) => (
                                            <Row className="list-item" key={index} noGutters>
                                                <Col md={1} xs={1}>
                                                    {index+1}
                                                </Col>
                                                <Col>
                                                    {user.name}
                                                </Col>
                                                <Col md={1} xs={1} className="text-center" />
                                                <Col md={1} xs={1} className="text-right">
                                                    <i className="material-icons">
                                                        chevron_right
                                                    </i>
                                                </Col>
                                            </Row>
                                        ))
                                    }
                                    </div>
                                </div>
                        }

                        <CreateContractor 
                            isOpen={this.state.createContractor} 
                            handleClose={() => this.setState({createContractor: false})}
                            handleSubmit={this.props.createContractor}
                        />
                        

                        <Button onClick={() => this.setState({createContractor: true})} className="mt-3">
                            Add new contractor
                        </Button>
                    </div>               

                </div>
            </div>
        )
    }

}


export default withRouter(connect((state : State) => ({
    contractors: state.contractors
}), ({
    getContractors,
    createContractor
}))(withRequestState(Contactors, [GET_CONTRACTORS_REQUEST])));